/**
 * Load MapLibre + explorer as soon as this boot script runs (defer).
 * Do not idle-delay: that pushed Speed Index later on mobile Lighthouse.
 */
(function () {
  var root = document.getElementById('venue-explorer');
  if (!root) return;
  var src = root.getAttribute('data-ve-script');
  if (!src || root.getAttribute('data-ve-booted') === '1') return;

  function prefetchMapLibre() {
    var css = root.getAttribute('data-maplibre-css-url');
    var js = root.getAttribute('data-maplibre-js-url');
    if (css && !document.querySelector('link[data-ve-maplibre-css], link[rel="stylesheet"][href="' + css + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = css;
      link.setAttribute('data-ve-maplibre-css', '1');
      document.head.appendChild(link);
    }
    if (js && !document.querySelector('script[data-ve-maplibre-js], script[src="' + js + '"]')) {
      var script = document.createElement('script');
      script.src = js;
      script.defer = true;
      script.setAttribute('data-ve-maplibre-js', '1');
      document.head.appendChild(script);
    }
  }

  function loadExplorer() {
    if (root.getAttribute('data-ve-booted') === '1') return;
    root.setAttribute('data-ve-booted', '1');
    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.body.appendChild(script);
  }

  prefetchMapLibre();
  loadExplorer();
})();
